import { LevelData } from '../level-data';

export const level6: LevelData = {
    name: 'Narrow Path',
    timeLimit: 80,
    track: [
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '-------',
        '  -----',
        '-------',
        '-------',
        '-------',
        '-----  ',
        '-------',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '  -----',
        '-------',
        '-------',
        '-------',
        '-----  ',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
